import Cookies from 'js-cookie'

export interface CookiePreferences {
  necessary: boolean // Always true, required for site function
  analytics: boolean
  marketing: boolean
}

const COOKIE_CONSENT_KEY = 'tv_cookie_consent'
const COOKIE_PREFERENCES_KEY = 'tv_cookie_preferences'

export const defaultPreferences: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
}

export function hasConsented(): boolean {
  return Cookies.get(COOKIE_CONSENT_KEY) === 'true'
}

export function getPreferences(): CookiePreferences {
  const stored = Cookies.get(COOKIE_PREFERENCES_KEY)
  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      return { ...defaultPreferences, ...parsed, necessary: true }
    } catch {
      return defaultPreferences
    }
  }
  return defaultPreferences
}

export function saveConsent(preferences: CookiePreferences): void {
  const prefs = { ...preferences, necessary: true }

  Cookies.set(COOKIE_CONSENT_KEY, 'true', { expires: 365, sameSite: 'lax' })
  Cookies.set(COOKIE_PREFERENCES_KEY, JSON.stringify(prefs), { expires: 365, sameSite: 'lax' })

  // Dispatch event for analytics/marketing scripts to listen to
  window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: prefs }))
}

export function acceptAll(): void {
  saveConsent({
    necessary: true,
    analytics: true,
    marketing: true,
  })
}

export function rejectAll(): void {
  saveConsent({
    necessary: true,
    analytics: false,
    marketing: false,
  })
}

export function revokeConsent(): void {
  Cookies.remove(COOKIE_CONSENT_KEY)
  Cookies.remove(COOKIE_PREFERENCES_KEY)
}
